import { render, staticRenderFns } from "./VacancyTest.vue?vue&type=template&id=0d84555f&scoped=true&"
import script from "./VacancyTest.vue?vue&type=script&lang=js&"
export * from "./VacancyTest.vue?vue&type=script&lang=js&"
import style0 from "./VacancyTest.vue?vue&type=style&index=0&id=0d84555f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d84555f",
  null
  
)

/* custom blocks */
import block0 from "./VacancyTest.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./VacancyTest.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VRow})
